module.exports = __webpack_public_path__ + "static/media/50.06ede1c2.svg";